module.exports = __webpack_public_path__ + "img/tubtb1.6eed5b6a.png";